import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmRegisterModal({show, handleClose, onConfirm, message}) {


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{direction:'rtl', textAlign:'right'}}
        centered
      >
        <Modal.Header className='bg-success' style={{height:'70px'}}>
          <div className='d-flex justify-content-between align-items-center w-100 text-center'>
            <div>
            <i className='fa fa-exclamation-circle text-white fs-1  me-2'></i>
            </div>
            <div className='text-white fs-5 me-5'>توجه</div>
            <div></div>

          </div>
        </Modal.Header>
        <Modal.Body className='text-center'>
            <div style={{fontSize:'.9rem', minHeight:"50px"}} className='d-flex justify-content-center align-items-center'>
                {message}
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" className='mx-auto' onClick={onConfirm}>متوجه شدم</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmRegisterModal;